import { ShareAdapter } from "./ShareAdapter";
export class TwitterShareAdapter extends ShareAdapter {
    doShare(data) {
        window.open('//www.twitter.com/share?url=' + encodeURIComponent(data.url) + '&text=' + encodeURIComponent(data.title), 'feedDialog', 'toolbar=0,status=0,width=626,height=253');
    }
}
